import { DateTime } from 'luxon';
import { AppThunk } from '../../../store/rootReducer';
import { rulerMetricsSelector } from '../../ruler/selectors/ruler.selectors';
import { STOP_RULER } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';
import { getRulerTimeStarted } from '../selectors/analytics-info.selectors';

export const trackStopRuler =
  (
    interaction: 'click' | 'keyboard' | 'escape',
    analyticsEventTrack = track,
  ): AppThunk =>
  (_, getState) => {
    const rulerInfo = rulerMetricsSelector(getState());
    const timeStarted = getRulerTimeStarted(getState());
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name: STOP_RULER,
      properties: {
        user_id: userId,
        ecg_id: ecgId,
        view,
        value: rulerInfo,
        interaction,
        time_spent_ms: DateTime.now().toMillis() - timeStarted,
      },
    });
  };
